/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cmspage_Error_Story_Not_Found1Inputs */

const vi_cmspage_error_story_not_found1 = /** @type {(inputs: Cmspage_Error_Story_Not_Found1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy câu chuyện này — có thể đã gỡ khỏi web.`)
};

/**

* @param {Cmspage_Error_Story_Not_Found1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspage_error_story_not_found1 = /** @type {((inputs?: Cmspage_Error_Story_Not_Found1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspage_Error_Story_Not_Found1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspage_error_story_not_found1(inputs)
});
export { cmspage_error_story_not_found1 as "cmsPage_error_story_not_found" }